import React from "react";
import { HStack, Box } from "@commonsku/design-system";
import NavBarGlobalSearch from "./NavBarGlobalSearch";
import ResourcesMenu from "./ResourcesMenu";
import RecentProjectsButton from "./RecentProjectsButton";
import NewProjectButton from "./NewProjectButton";
import TasksMenu from "./TasksMenu";
import ProfileMenu from "./ProfileMenu";
import CommunityNotificationsButton from "./CommunityNotificationsButton";
import AssumeIdentity from "../AssumeIdentity";

interface NavBarContainerProps {
  canSearch: boolean;
  children?: React.ReactNode;
}

const SIDEBAR_WIDTH = "11rem";
const GLOBAL_SEARCH_MAX_WIDTH = "31.375rem";

const RESPONSIVE_SIDEBAR_CSS = {
  "@media screen and (min-width: 40em)": {
    marginInlineStart: SIDEBAR_WIDTH,
    width: `calc(100% - ${SIDEBAR_WIDTH})`,
  },
};

const NavBarContainer = ({ canSearch, children }: NavBarContainerProps) => {
  return (
    <Box width="full" css={RESPONSIVE_SIDEBAR_CSS}>
      <HStack
        justifyContent="flex-start"
        width="full"
        minHeight="16"
        fontFamily="body"
        paddingX="4"
        paddingY="3"
        background="bg.panel"
        borderBottomWidth="1px"
        borderBottomColor="border.muted"
      >
        {canSearch && (
          <Box width="full" minWidth="0" maxWidth={GLOBAL_SEARCH_MAX_WIDTH}>
            <NavBarGlobalSearch />
          </Box>
        )}
        <RecentProjectsButton />
        <NewProjectButton />
        <HStack marginInlineStart="auto" flexShrink="0">
          <AssumeIdentity />
          <TasksMenu />
          <ResourcesMenu />
          <CommunityNotificationsButton />
          <ProfileMenu />
        </HStack>
      </HStack>
      {children && (
        <HStack
          justifyContent="space-between"
          width="full"
          fontFamily="body"
          paddingX="4"
          paddingY="3"
        >
          {children}
        </HStack>
      )}
    </Box>
  );
};

export default NavBarContainer;
